import * as e from "react";
import i from "../lib/IconBase.es.js";
import a from "../defs/Highlighter.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(i, { ref: t, ...r, weights: a }));
o.displayName = "HighlighterIcon";
const g = o;
export {
  g as Highlighter,
  o as HighlighterIcon
};
